import {numberProps} from '@/util/config';
import axios from 'axios';
import qs from 'qs';

const BASE_URL = '/';

function getStyle(item, equipsMap) {
	let style = {};
	console.log('item11',item)
	console.log('equipsMappre',equipsMap)
	if (item && item.style) {
		for (let key in item.style) {
			if (key === 'transform') {
				style[key] = `rotate(${item.style[key]}deg)`;
			} else if (numberProps.includes(key)) {
				style[key] = item.style[key] + 'px';
			} else if (item.style[key]) {
				style[key] = item.style[key];
			} else {
				continue;
			}
		}
		if (item.type && item.type === 'custom' && !item.style['z-index']) {
			style['z-index'] = 0
		} else if (item.type && item.type === 'equip' && !item.style['z-index']) {
			style['z-index'] = 5
		}
		
		if (!item || !item.no) {
			return style
		}
	
		
		const equipInfo = equipsMap.get(item.no);

		if (equipInfo) {
			const status =(equipInfo.status)
			console.log(status)
			if (status=='正常'){
				style.backgroundColor = '#53ba68';
					style.color = 'black';
				

			}else if(status=='维修'){
				style.backgroundColor = '#f8433e';
					style.color = 'black';

			}
			else if(status=='保养'){
				style.backgroundColor = 'yellow';
					style.color = 'black';

			}
			else if(status=='空闲'){
				style.backgroundColor = '#b5b5b5';
					style.color = 'black';

			}
			
		}
	}
	
	// console.log('style', item, style);
	return style;
}

function get(url, params = {}) {
	return axios.get(BASE_URL + url + '&' + qs.stringify(params)).then(res => {
		return res;
	});
}

function post(url, params = {}) {
	return axios.post(BASE_URL + url, qs.stringify(params)).then(res => {
		return res;
	});
}

export {getStyle, get, post};
